import { Flex } from '@chakra-ui/react';
import React from 'react';
import TransactionsTable from '../components/Tables/components/Transactions';

function Transactions() {
  const columns = React.useMemo(
    () => [
      {
        header: 'Started (UTC-0)',
        accessorKey: 'started',
      },
      {
        header: 'id',
        accessorKey: 'id',
      },
      {
        header: 'Status',
        accessorKey: 'status',
      },
      {
        header: 'amount',
        accessorKey: 'amount',
      },
      {
        header: 'env',
        accessorKey: 'env',
      },
    ],
    []
  );

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px' }}>
      <TransactionsTable title={'Транзакции'} columns={columns} />
    </Flex>
  );
}

export default Transactions;
